export default __webpack_public_path__ + "static/media/history_screen.fced2fea.png";